import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';
import { ApiService } from '@app/services/api/api.service';

import * as fromProductShipments from '@core/reducers/product-shipment.reducer';
import * as fromRoot from '@core/reducers/root.reducer';
import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';
import * as ProductShipmentActions from '@core/actions/product-shipment.actions';

@Component({
  selector: 'app-proforma-weighted-fob-modal',
  templateUrl: './proforma-weighted-fob-modal.component.html',
  styleUrls: ['./proforma-weighted-fob-modal.component.css']
})
export class ProformaWeightedFobModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<any>,
    private api: ApiService
  ) {}

  proforma;

  productCountryShipments$ = this.store.pipe(
    select(fromProductShipments.getAll)
  );

  productCountryEntities$ = this.store.pipe(
    select(fromRoot.getProductCountries)
  );

  products$ = this.store.pipe(select(fromRoot.getProducts));
  // productsEntities$ = this.store.pipe(select(fromRoot.getProductEntities));
  // productCountryRed;
  // productRed;

  ngOnInit() {
    // console.log('proforma', this.proforma);
    this.store.dispatch(
      new ProductShipmentActions.LoadByFollow(
        this.proforma.FollowId,
        null,
        this.proforma.id
      )
    );
  }

  descriptionColor(pcs) {
    return pcs.ProductCountry.Product.code;
  }
}
